import React from "react";
import PropTypes from "prop-types";

const AdvisorIcon = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: (props.className || null) + " chat-icon advisor-icon"
  });
};

AdvisorIcon.propTypes = {
  className: PropTypes.string
};
export default AdvisorIcon;